import { CollectionPage } from '../../components/pages/collections/CollectionPage'
export default CollectionPage
